import { Maya } from "./components/Maya.jsx";
import {
  BINARY_SYSTEM,
  FONT,
  MAYA_SYSTEM,
  ROMAN_SYSTEM
} from "./defaults";
import basket from "./images/basket.png";
import cart from "./images/cart.png";
import corn from "./images/corn.png";
import { levelExchange } from "./strings.jsx";


export const increaseProgress = (levelProgress, setLevelProgress, level, whichSystem) => {
  const newProgress = [...levelProgress];
  newProgress[level] += 1;
  setLevelProgress(whichSystem, newProgress);
};

/**
 * Converts a number from a recognized alternate numeral system to decimal.
 * @param {int} whichSystem 
 * @param {} number  For Roman and binary, this should be a number or string. For Maya, this should be an array of length 3.
 * @returns A decimal number.
 */
export function convertToDecimal(whichSystem, number) {
    switch(whichSystem) {
      case ROMAN_SYSTEM:
        return romanToDec(String(number));
      case BINARY_SYSTEM:
        return binaryToDec(String(number));
      case MAYA_SYSTEM:
        return mayaToDec(number);
      default:
        console.log("Undefined numeral system. Something went WRONG!")
    }
  }

/**
 * Converts a number from decimal to a recognized alternate numeral system.
 * @param {int} whichSystem 
 * @param {number} number
 * @returns Roman and binary numbers as a string, Maya numbers as an array of size 3, of form [# of corn, # of baskets, # of carts].
 */
export function convertToAlternate(whichSystem, number) {
switch(whichSystem) {
    case ROMAN_SYSTEM:
    return decToRoman(number);
    case BINARY_SYSTEM:
    return decToBinary(number);
    case MAYA_SYSTEM: 
    return decToMaya(number);
    default:
    console.log("Undefined numeral system. Something went WRONG!")
}
}


/**
 * Converts additive Roman numeral to decimal. Works for text like "MMCXII". Currently supports only additive notation, flags subtractive notation as invalid.
 * @param {String} numberString
 * @returns A decimal number or displays a message if input was malformed.
 */
function romanToDec(numberString) {
    numberString = numberString.toUpperCase(); // Easier to check. Also consistent with input style.
    let outputDec = 0;
    let numberArray = Array.from(numberString);
    let charCount = {}; // Used to count how often each char occurs in the string. C,X,I: more than 4 = illegal. D,L,V: more than 1 = illegal. M: Anything amount ok, for now.

    for (let i = 0; i < numberString.length; ++i) {
        let nextChar=numberArray[i];
        switch (nextChar) {
            case "M":
                outputDec+=1000;
                break;
            case "D":
                if (i < (numberString.length-1) && ["M"].includes(numberArray[i+1])) { // checks if next char is an invalid char.
                    return romanNotValid();
                }
                charCount["D"] = (charCount["D"] || 0) + 1;
                if (charCount["D"] > 1) {
                    return romanNotValid();
                }
                outputDec+=500;
                break;
            case "C":
                if (i < (numberString.length-1) && ["M","D"].includes(numberArray[i+1])) {
                    return romanNotValid();
                }
                charCount["C"] = (charCount["C"] || 0) + 1;
                if (charCount["C"] > 4) {
                    return romanNotValid();
                }
                outputDec+=100;
                break;
            case "L":
                if (i < (numberString.length-1) && ["M","D","C"].includes(numberArray[i+1])) {
                    return romanNotValid();
                }
                charCount["L"] = (charCount["L"] || 0) + 1;
                if (charCount["L"] > 1) {
                    return romanNotValid();
                }
                outputDec+=50;
                break;
            case "X":
                if (i < (numberString.length-1) && ["M","D","C","L"].includes(numberArray[i+1])) {
                    return romanNotValid();
                }
                charCount["X"] = (charCount["X"] || 0) + 1;
                if (charCount["X"] > 4) {
                    return romanNotValid();
                }
                outputDec+=10;
                break;
            case "V":
                if (i < (numberString.length-1) && ["M","D","C","L","X"].includes(numberArray[i+1])) {
                    return romanNotValid();
                }
                charCount["V"] = (charCount["V"] || 0) + 1;
                if (charCount["V"] > 1) {
                    return romanNotValid();
                }
                outputDec+=5;
                break;
            case "I":
                if (i < (numberString.length-1) && ["M","D","C","L","X","V"].includes(numberArray[i+1])) {
                    return romanNotValid();
                }
                charCount["I"] = (charCount["I"] || 0) + 1;
                if (charCount["I"] > 4) {
                    return romanNotValid();
                }
                outputDec+=1;
                break;
            default:
                return romanNotValid();
        }

    }
    return outputDec;
}

/**
 * Converts binary to decimal.
 * @param {String} numberString 
 * @returns A decimal number or displays a message if input was malformed.
 */
function binaryToDec(numberString) {
    if(/(^0$|^1[01]*$)/.test(numberString)) { // Regex to check if string consists of something other than 0s and 1s.
      let outputDec = parseInt(numberString,2);
      return outputDec;  
    }
    return binaryNotValid();
}

/**
 * 
 * @param {Array} number 
 * @returns A decimal number.
 */
function mayaToDec(number) {
    let outputDec = 0;
    number.map( (value, index) => {
        if (index === 0) { // Corn
            outputDec += value;
        } else if (index === 1) { // Basket
            outputDec += (value * 5);
        } else { // Cart
            outputDec += (value * 20);
        }
    })
    return outputDec;
}

/**
 * Displays message to screen informing player that input Roman numeral is malformed.
 * @param
 * @returns 
 */
function romanNotValid() {
    console.log("Invalid Roman numeral!");
    return -1;
}

/**
 * Displays message to screen informing player that input binary is malformed.
 * @param
 * @returns 
 */
function binaryNotValid() {
    console.log("Invalid binary!");
    return -1;
}

/**
 * Converts input decimal to Roman string.
 * @param {number} number 
 */
export function decToRoman(number) {
    if (number <= 0) {
        console.log("decToRoman: number must be positive!");
        return "";
    }
    let outputString = "";
    while (number > 0) {
        if (number >= 1000) {
            outputString += "M";
            number -= 1000;
            continue;
        }
        if (number >= 500) {
            outputString += "D";
            number -= 500;
            continue;
        }
        if (number >= 100) {
            outputString += "C";
            number -= 100;
            continue;
        }
        if (number >= 50) {
            outputString += "L";
            number -= 50;
            continue;
        }
        if (number >= 10) {
            outputString += "X";
            number -= 10;
            continue;
        }
        if (number >= 5) {
            outputString += "V";
            number -= 5;
            continue;
        }
        if (number >= 1) {
            outputString += "I";
            number -= 1;
            continue;
        }
    }
    return outputString;
}

export function decToBinary(number) {
    if (number <= 0) {
        console.log("decToBinary: number must be positive!");
        return;
    }
    // Note that if code reaches here, number is strictly positive.
    let outputString = Number(number).toString(2);
    return outputString;
}

export function decToMaya(number) {
    if (number <= 0) {
        console.log("decToMaya: number must be positive!");
        return;
    }
    // Note that if code reaches here, number is strictly positive.
    let outputArray = [0,0,0];
    while (number > 0) {
        if (number >= 20) {
            ++outputArray[2]; // Add a cart.
            number -= 20;
            continue;
        }
        if (number >= 5) {
            ++outputArray[1]; // Add a basket.
            number -= 5;
            continue;
        }
        if (number >= 1) {
            ++outputArray[0]; // Add corn.
            number -= 1;
            continue;
        }
    }
    return outputArray;
}

/**
 * LLM-generated. Calculates character frequencies for all Roman characters in a string.
 * @param {*} str 
 * @returns Object with key-value pairs. Example output for 'hello world': { h: 1, e: 1, l: 3, o: 2, ' ': 1, w: 1, r: 1, d: 1, '!': 1 }
 */
export function countRomanCharOccurrences(str) {
    const romanChars = "IVXLCDM";
    return Array.from(str).reduce((acc, char) => {
      if (romanChars.includes(char)) {
        acc[char] = (acc[char] || 0) + 1;
      }
      return acc;
    }, Object.fromEntries(romanChars.split("").map((char) => [char, 0]))); // For romanChars, outputs them with a value of 0 even if they don't occur. If other chars don't occur, they are not output at all.
  }
  
/**
 * Renders Maya items as images correctly formatted.
 * @param {*} droppedItems Array containing information on how many items of each type should be rendered. [# of corn plants, # of baskets, # of carts]
 * @param {*} itemSize How big items displayed should be. In dvh.
 * @returns Child component containing HTML tags.
 */
export function RenderMayaImages({droppedItems, itemSize}) {
    const mayaImages = [corn, basket, cart];

    const containerStyle = {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        justifyContent: "center",
      };
      
      const containerArrayStyle = {
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap",
        rowGap: "3dvh",
        justifyContent: "center",
        textShadow: "0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5)",
        fontFamily: FONT,
        borderRadius: "0.25em",
      }

    let mayaArray = [...droppedItems];
    let containerArray = [];
    if (mayaArray[0] > 0) { // Corn is rendered using a different style than the rest, because corn is rendered next to each other, while the rest is rendered above/below each other.
      containerArray.push(
        <div style={containerStyle}>
          {
            Array.from({length: mayaArray[0]}).map( (index) => { // Use array construct to render corn image exactly mayaArray[0] times.
                return <span key={index} style={{width: itemSize+"dvh", height: itemSize+"dvh"}}><img src={mayaImages[0]} alt="maya-image" style={{ width: "100%", height: "100%", filter: "drop-shadow(0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5))",}}/></span>
            })
          }
        </div>
      )
    }
    for (let i = 1; i < mayaArray.length; ++i) {
      while (mayaArray[i] > 0) {
        containerArray.push(
            <span key={[i, mayaArray[i]]} style={{width: (itemSize*4)+"dvh", height: itemSize+"dvh"}}><img src={mayaImages[i]} alt="maya-image" style={{ width: "100%", height: "100%", filter: "drop-shadow(0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5))",}}/></span>
        ) 
        --mayaArray[i];
      }
    }
  
    return (
      <div style={containerArrayStyle}>
        {containerArray}
      </div>
    );
  }


  /**
 * Renders Maya items as objects correctly formatted. Also renders one exchange button for each item type.
 * @param {*} droppedItems Array containing information on how many items of each type should be rendered. [# of corn plants, # of baskets, # of carts]
 * @param {*} itemSize How big items displayed should be. In dvh.
 * @returns Child component containing HTML tags.
 */
export function RenderMayaObjects({droppedItems, itemSize, handleExchange, disableInput}) {
    const mayaImages = [corn, basket, cart];
    let scaledSize = droppedItems[1] > 3 ? 4*itemSize/droppedItems[1] : itemSize; // If many baskets are rendered, we scale them down. Not used for corn.
    let containerHeight = scaledSize*1.5
    
    const containerStyle = {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        rowGap: "1dvh",
        width: (4*itemSize)+"dvh", // 4 corn plants per row max.
        height: containerHeight+"dvh",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "0.5em",
        position: "relative"
      };
      
      const containerArrayStyle = {
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap",
        justifyContent: "center",
        textShadow: "0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5)",
        fontFamily: FONT,
        borderRadius: "0.25em",
      }

      const exchangeStyle = {
          padding: "1dvh",
          width: "10dvh",
          fontFamily: FONT,
          color: "white",
          fontSize: "1.6dvh",
          textShadow: "0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5)",
          position: "absolute",
          top: "50%",
          left: "38%",
          transform: "translate(-50%, -50%)"
        };

    let mayaArray = [...droppedItems];
    let containerArray = [];
    let exchangeButtonArray = [];

    // Render corn.
    if (mayaArray[0] > 0) { // Corn is rendered using a different style than the rest, because corn is rendered horizontally, while the rest is rendered vertically.

      // Render exchange button.
      exchangeButtonArray.push(
        <div style={{...containerStyle, width: exchangeStyle.width, height: (3*itemSize)+"dvh"}}> {/* 3 rows of corn should fit in this container. */}
          {handleExchange && <span style={{marginRight: "6dvh"}}><button onClick={() => handleExchange(0)} style={{...exchangeStyle}} className="exchange-button" disabled={disableInput}>{levelExchange}</button></span>} {/* Render button only if handleExchange was passed. */}
        </div>
      )
      
      containerArray.push(
        <div style={{...containerStyle, height: (3*itemSize)+"dvh", width: 4*itemSize+"dvh"}}> {/* 3 rows of corn should fit in this container. */}
          {
            Array.from({length: mayaArray[0]}).map( (index) => { // Use array construct to render corn image exactly mayaArray[0] times.
              return <span key={index} style={{height: itemSize+"dvh"}}><Maya mayaImage={mayaImages[0]} id={[0, 0]} alt="maya-image" isCorn={true} itemSize={itemSize}/></span>
            })
          }
        </div>
      )
    }

    // Render baskets and carts.
    for (let i = 1; i < mayaArray.length; ++i) {

      // Render exchange button. One for each item type.
      if (mayaArray[i] > 0) {
        const heightOfBlock = mayaArray[i]*containerHeight; // Height of all rendered baskets or carts in sum, respectively. Number of baskets/carts * height of one basket/cart. Used to center exchange button right in the middle.
        exchangeButtonArray.push(
          <div style={{...containerStyle, height: heightOfBlock+"dvh", width: exchangeStyle.width}}>
            {handleExchange && <span style={{marginRight: "6dvh"}}><button onClick={() => handleExchange(i)} style={{...exchangeStyle}} className="exchange-button" disabled={disableInput}>{levelExchange}</button></span>} {/* Render button only if handleExchange was passed. */}
          </div>
        )
      }

      while (mayaArray[i] > 0) {
        containerArray.push(
          <div style={containerStyle}>
            <div style={{display: "flex", flexDirection: "row"}}>
                <span key={[i, mayaArray[i]]} style={{height: scaledSize+"dvh"}}><Maya mayaImage={mayaImages[i]} id={[i, 0]} alt="maya-image" isCorn={false} itemSize={scaledSize}/></span>
            </div>
          </div>
        ) 
        --mayaArray[i];
      }
    }
  
    return (
      <div style={{display: "flex", flexDirection: "row"}}>
        <div style={{...containerArrayStyle, justifyContent: "left", marginRight: "3dvh"}}>
          {exchangeButtonArray}
        </div>
        <div style={containerArrayStyle}>
          {containerArray}
        </div>
      </div>
    );
  }